<template lang="pug">
section.single
  Header
  .container
  Footer
</template>

<script>
// import { getData, postData } from '../utils/api'

// const otherUrl = `${process.env.VUE_APP_APP_PROTOCOL}://${process.env.VUE_APP_APP_DOMAIN}/*/`

const page = {
  id: 'top',
  title: 'トップ'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      app: {
        name: process.env.VUE_APP_NAME
      },
      page: page
    }
  },
  async created () {
    /*
    if (!this.$auth.isAuthenticated) {
      this.login()
    } else {
      await postData(`/confirmUser`,{
        email: this.$auth.user.email
      }).then((ret) => {
        if (ret) {
          window.location.href = otherUrl.replace('*', ret)
        } else {
          this.$bvModal.msgBoxOk('登録情報の取得に失敗しました').then(async () => {
            await this.$store.commit('clearAccessToken')
            this.$auth.logout()
          })
        }
      }).catch((err) => {
        console.error(err)
        this.$bvModal.msgBoxOk('登録情報の取得に失敗しました').then(async () => {
          await this.$store.commit('clearAccessToken')
          this.$auth.logout()
        })
      })
    }
    */
  },
  methods: {
    login () {
      this.$auth.loginWithRedirect()
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
